/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * AgencyOS API
 * API AgencyOS (/api/v1). Le client des apps est généré depuis ce schéma.
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AiTestRequestRequest,
  AiTestResult,
  Applied,
  ApplyServicesRequest,
  ImportedContract,
  ImportedContractRequest,
  Library,
  OnboardingProgress,
  OnboardingProgressLibraryRetrieveParams,
  OnboardingState,
  PatchedResumeRequest,
  PublishedSite,
  StepActionRequest
} from '.././model';

import { apiFetch } from '../../http';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Existing contracts (PDF, Word…) kept to be rewritten as templates later.
 */
export type onboardingContractsListResponse200 = {
  data: ImportedContract[]
  status: 200
}
    
export type onboardingContractsListResponseSuccess = (onboardingContractsListResponse200) & {
  headers: Headers;
};
;

export type onboardingContractsListResponse = (onboardingContractsListResponseSuccess)

export const getOnboardingContractsListUrl = () => {


  

  return `/api/v1/onboarding/contracts/`
}

export const onboardingContractsList = async ( options?: RequestInit): Promise<onboardingContractsListResponse> => {
  
  return apiFetch<onboardingContractsListResponse>(getOnboardingContractsListUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getOnboardingContractsListQueryKey = () => {
    return [
    `/api/v1/onboarding/contracts/`
    ] as const;
    }

    
export const getOnboardingContractsListQueryOptions = <TData = Awaited<ReturnType<typeof onboardingContractsList>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof onboardingContractsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOnboardingContractsListQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof onboardingContractsList>>> = ({ signal }) => onboardingContractsList({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof onboardingContractsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OnboardingContractsListQueryResult = NonNullable<Awaited<ReturnType<typeof onboardingContractsList>>>
export type OnboardingContractsListQueryError = unknown


export function useOnboardingContractsList<TData = Awaited<ReturnType<typeof onboardingContractsList>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof onboardingContractsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof onboardingContractsList>>,
          TError,
          Awaited<ReturnType<typeof onboardingContractsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOnboardingContractsList<TData = Awaited<ReturnType<typeof onboardingContractsList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof onboardingContractsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof onboardingContractsList>>,
          TError,
          Awaited<ReturnType<typeof onboardingContractsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOnboardingContractsList<TData = Awaited<ReturnType<typeof onboardingContractsList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof onboardingContractsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useOnboardingContractsList<TData = Awaited<ReturnType<typeof onboardingContractsList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof onboardingContractsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOnboardingContractsListQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Existing contracts (PDF, Word…) kept to be rewritten as templates later.
 */
export type onboardingContractsCreateResponse201 = {
  data: ImportedContract
  status: 201
}
    
export type onboardingContractsCreateResponseSuccess = (onboardingContractsCreateResponse201) & {
  headers: Headers;
};
;

export type onboardingContractsCreateResponse = (onboardingContractsCreateResponseSuccess)

export const getOnboardingContractsCreateUrl = () => {


  

  return `/api/v1/onboarding/contracts/`
}

export const onboardingContractsCreate = async (importedContractRequest: ImportedContractRequest, options?: RequestInit): Promise<onboardingContractsCreateResponse> => {
    const formData = new FormData();
if(importedContractRequest.title !== undefined) {
 formData.append(`title`, importedContractRequest.title)
 }
formData.append(`file`, importedContractRequest.file)

  return apiFetch<onboardingContractsCreateResponse>(getOnboardingContractsCreateUrl(),
  {      
    ...options,
    method: 'POST'
    ,
    body: 
      formData,
  }
);}




export const getOnboardingContractsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof onboardingContractsCreate>>, TError,{data: ImportedContractRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof onboardingContractsCreate>>, TError,{data: ImportedContractRequest}, TContext> => {

const mutationKey = ['onboardingContractsCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof onboardingContractsCreate>>, {data: ImportedContractRequest}> = (props) => {
          const {data} = props ?? {};

          return  onboardingContractsCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type OnboardingContractsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof onboardingContractsCreate>>>
    export type OnboardingContractsCreateMutationBody = ImportedContractRequest
    export type OnboardingContractsCreateMutationError = unknown

    export const useOnboardingContractsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof onboardingContractsCreate>>, TError,{data: ImportedContractRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof onboardingContractsCreate>>,
        TError,
        {data: ImportedContractRequest},
        TContext
      > => {

      const mutationOptions = getOnboardingContractsCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Existing contracts (PDF, Word…) kept to be rewritten as templates later.
 */
export type onboardingContractsRetrieveResponse200 = {
  data: ImportedContract
  status: 200
}
    
export type onboardingContractsRetrieveResponseSuccess = (onboardingContractsRetrieveResponse200) & {
  headers: Headers;
};
;

export type onboardingContractsRetrieveResponse = (onboardingContractsRetrieveResponseSuccess)

export const getOnboardingContractsRetrieveUrl = (id: string,) => {


  

  return `/api/v1/onboarding/contracts/${id}/`
}

export const onboardingContractsRetrieve = async (id: string, options?: RequestInit): Promise<onboardingContractsRetrieveResponse> => {
  
  return apiFetch<onboardingContractsRetrieveResponse>(getOnboardingContractsRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getOnboardingContractsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/onboarding/contracts/${id}/`
    ] as const;
    }

    
export const getOnboardingContractsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof onboardingContractsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof onboardingContractsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOnboardingContractsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof onboardingContractsRetrieve>>> = ({ signal }) => onboardingContractsRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof onboardingContractsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OnboardingContractsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof onboardingContractsRetrieve>>>
export type OnboardingContractsRetrieveQueryError = unknown


export function useOnboardingContractsRetrieve<TData = Awaited<ReturnType<typeof onboardingContractsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof onboardingContractsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof onboardingContractsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof onboardingContractsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOnboardingContractsRetrieve<TData = Awaited<ReturnType<typeof onboardingContractsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof onboardingContractsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof onboardingContractsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof onboardingContractsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOnboardingContractsRetrieve<TData = Awaited<ReturnType<typeof onboardingContractsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof onboardingContractsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useOnboardingContractsRetrieve<TData = Awaited<ReturnType<typeof onboardingContractsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof onboardingContractsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOnboardingContractsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Existing contracts (PDF, Word…) kept to be rewritten as templates later.
 */
export type onboardingContractsDestroyResponse204 = {
  data: void
  status: 204
}
    
export type onboardingContractsDestroyResponseSuccess = (onboardingContractsDestroyResponse204) & {
  headers: Headers;
};
;

export type onboardingContractsDestroyResponse = (onboardingContractsDestroyResponseSuccess)

export const getOnboardingContractsDestroyUrl = (id: string,) => {


  

  return `/api/v1/onboarding/contracts/${id}/`
}

export const onboardingContractsDestroy = async (id: string, options?: RequestInit): Promise<onboardingContractsDestroyResponse> => {
  
  return apiFetch<onboardingContractsDestroyResponse>(getOnboardingContractsDestroyUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}




export const getOnboardingContractsDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof onboardingContractsDestroy>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof onboardingContractsDestroy>>, TError,{id: string}, TContext> => {

const mutationKey = ['onboardingContractsDestroy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof onboardingContractsDestroy>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  onboardingContractsDestroy(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type OnboardingContractsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof onboardingContractsDestroy>>>
    
    export type OnboardingContractsDestroyMutationError = unknown

    export const useOnboardingContractsDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof onboardingContractsDestroy>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof onboardingContractsDestroy>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getOnboardingContractsDestroyMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * The wizard of the agency: only its owner and its managers run it.
 */
export type onboardingProgressListResponse200 = {
  data: OnboardingProgress[]
  status: 200
}
    
export type onboardingProgressListResponseSuccess = (onboardingProgressListResponse200) & {
  headers: Headers;
};
;

export type onboardingProgressListResponse = (onboardingProgressListResponseSuccess)

export const getOnboardingProgressListUrl = () => {


  

  return `/api/v1/onboarding/progress/`
}

export const onboardingProgressList = async ( options?: RequestInit): Promise<onboardingProgressListResponse> => {
  
  return apiFetch<onboardingProgressListResponse>(getOnboardingProgressListUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getOnboardingProgressListQueryKey = () => {
    return [
    `/api/v1/onboarding/progress/`
    ] as const;
    }

    
export const getOnboardingProgressListQueryOptions = <TData = Awaited<ReturnType<typeof onboardingProgressList>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof onboardingProgressList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOnboardingProgressListQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof onboardingProgressList>>> = ({ signal }) => onboardingProgressList({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof onboardingProgressList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OnboardingProgressListQueryResult = NonNullable<Awaited<ReturnType<typeof onboardingProgressList>>>
export type OnboardingProgressListQueryError = unknown


export function useOnboardingProgressList<TData = Awaited<ReturnType<typeof onboardingProgressList>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof onboardingProgressList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof onboardingProgressList>>,
          TError,
          Awaited<ReturnType<typeof onboardingProgressList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOnboardingProgressList<TData = Awaited<ReturnType<typeof onboardingProgressList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof onboardingProgressList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof onboardingProgressList>>,
          TError,
          Awaited<ReturnType<typeof onboardingProgressList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOnboardingProgressList<TData = Awaited<ReturnType<typeof onboardingProgressList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof onboardingProgressList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useOnboardingProgressList<TData = Awaited<ReturnType<typeof onboardingProgressList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof onboardingProgressList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOnboardingProgressListQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * The wizard of the agency: only its owner and its managers run it.
 */
export type onboardingProgressRetrieveResponse200 = {
  data: OnboardingProgress
  status: 200
}
    
export type onboardingProgressRetrieveResponseSuccess = (onboardingProgressRetrieveResponse200) & {
  headers: Headers;
};
;

export type onboardingProgressRetrieveResponse = (onboardingProgressRetrieveResponseSuccess)

export const getOnboardingProgressRetrieveUrl = (id: string,) => {


  

  return `/api/v1/onboarding/progress/${id}/`
}

export const onboardingProgressRetrieve = async (id: string, options?: RequestInit): Promise<onboardingProgressRetrieveResponse> => {
  
  return apiFetch<onboardingProgressRetrieveResponse>(getOnboardingProgressRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getOnboardingProgressRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/onboarding/progress/${id}/`
    ] as const;
    }

    
export const getOnboardingProgressRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof onboardingProgressRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof onboardingProgressRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOnboardingProgressRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof onboardingProgressRetrieve>>> = ({ signal }) => onboardingProgressRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof onboardingProgressRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OnboardingProgressRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof onboardingProgressRetrieve>>>
export type OnboardingProgressRetrieveQueryError = unknown


export function useOnboardingProgressRetrieve<TData = Awaited<ReturnType<typeof onboardingProgressRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof onboardingProgressRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof onboardingProgressRetrieve>>,
          TError,
          Awaited<ReturnType<typeof onboardingProgressRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOnboardingProgressRetrieve<TData = Awaited<ReturnType<typeof onboardingProgressRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof onboardingProgressRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof onboardingProgressRetrieve>>,
          TError,
          Awaited<ReturnType<typeof onboardingProgressRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOnboardingProgressRetrieve<TData = Awaited<ReturnType<typeof onboardingProgressRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof onboardingProgressRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useOnboardingProgressRetrieve<TData = Awaited<ReturnType<typeof onboardingProgressRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof onboardingProgressRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOnboardingProgressRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * The « Tester l'IA » sandbox with a first question; nothing is sent to anybody.
 */
export type onboardingProgressAiTestCreateResponse200 = {
  data: AiTestResult
  status: 200
}
    
export type onboardingProgressAiTestCreateResponseSuccess = (onboardingProgressAiTestCreateResponse200) & {
  headers: Headers;
};
;

export type onboardingProgressAiTestCreateResponse = (onboardingProgressAiTestCreateResponseSuccess)

export const getOnboardingProgressAiTestCreateUrl = () => {


  

  return `/api/v1/onboarding/progress/ai-test/`
}

export const onboardingProgressAiTestCreate = async (aiTestRequestRequest: AiTestRequestRequest, options?: RequestInit): Promise<onboardingProgressAiTestCreateResponse> => {
  
  return apiFetch<onboardingProgressAiTestCreateResponse>(getOnboardingProgressAiTestCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      aiTestRequestRequest,)
  }
);}




export const getOnboardingProgressAiTestCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof onboardingProgressAiTestCreate>>, TError,{data: AiTestRequestRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof onboardingProgressAiTestCreate>>, TError,{data: AiTestRequestRequest}, TContext> => {

const mutationKey = ['onboardingProgressAiTestCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof onboardingProgressAiTestCreate>>, {data: AiTestRequestRequest}> = (props) => {
          const {data} = props ?? {};

          return  onboardingProgressAiTestCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type OnboardingProgressAiTestCreateMutationResult = NonNullable<Awaited<ReturnType<typeof onboardingProgressAiTestCreate>>>
    export type OnboardingProgressAiTestCreateMutationBody = AiTestRequestRequest
    export type OnboardingProgressAiTestCreateMutationError = unknown

    export const useOnboardingProgressAiTestCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof onboardingProgressAiTestCreate>>, TError,{data: AiTestRequestRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof onboardingProgressAiTestCreate>>,
        TError,
        {data: AiTestRequestRequest},
        TContext
      > => {

      const mutationOptions = getOnboardingProgressAiTestCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * GET opens the wizard (the timer starts the first time); PATCH saves the resume point.
 */
export type onboardingProgressCurrentRetrieveResponse200 = {
  data: OnboardingState
  status: 200
}
    
export type onboardingProgressCurrentRetrieveResponseSuccess = (onboardingProgressCurrentRetrieveResponse200) & {
  headers: Headers;
};
;

export type onboardingProgressCurrentRetrieveResponse = (onboardingProgressCurrentRetrieveResponseSuccess)

export const getOnboardingProgressCurrentRetrieveUrl = () => {


  

  return `/api/v1/onboarding/progress/current/`
}

export const onboardingProgressCurrentRetrieve = async ( options?: RequestInit): Promise<onboardingProgressCurrentRetrieveResponse> => {
  
  return apiFetch<onboardingProgressCurrentRetrieveResponse>(getOnboardingProgressCurrentRetrieveUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getOnboardingProgressCurrentRetrieveQueryKey = () => {
    return [
    `/api/v1/onboarding/progress/current/`
    ] as const;
    }

    
export const getOnboardingProgressCurrentRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof onboardingProgressCurrentRetrieve>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof onboardingProgressCurrentRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOnboardingProgressCurrentRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof onboardingProgressCurrentRetrieve>>> = ({ signal }) => onboardingProgressCurrentRetrieve({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof onboardingProgressCurrentRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OnboardingProgressCurrentRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof onboardingProgressCurrentRetrieve>>>
export type OnboardingProgressCurrentRetrieveQueryError = unknown


export function useOnboardingProgressCurrentRetrieve<TData = Awaited<ReturnType<typeof onboardingProgressCurrentRetrieve>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof onboardingProgressCurrentRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof onboardingProgressCurrentRetrieve>>,
          TError,
          Awaited<ReturnType<typeof onboardingProgressCurrentRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOnboardingProgressCurrentRetrieve<TData = Awaited<ReturnType<typeof onboardingProgressCurrentRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof onboardingProgressCurrentRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof onboardingProgressCurrentRetrieve>>,
          TError,
          Awaited<ReturnType<typeof onboardingProgressCurrentRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOnboardingProgressCurrentRetrieve<TData = Awaited<ReturnType<typeof onboardingProgressCurrentRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof onboardingProgressCurrentRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useOnboardingProgressCurrentRetrieve<TData = Awaited<ReturnType<typeof onboardingProgressCurrentRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof onboardingProgressCurrentRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOnboardingProgressCurrentRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * GET opens the wizard (the timer starts the first time); PATCH saves the resume point.
 */
export type onboardingProgressCurrentPartialUpdateResponse200 = {
  data: OnboardingState
  status: 200
}
    
export type onboardingProgressCurrentPartialUpdateResponseSuccess = (onboardingProgressCurrentPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type onboardingProgressCurrentPartialUpdateResponse = (onboardingProgressCurrentPartialUpdateResponseSuccess)

export const getOnboardingProgressCurrentPartialUpdateUrl = () => {


  

  return `/api/v1/onboarding/progress/current/`
}

export const onboardingProgressCurrentPartialUpdate = async (patchedResumeRequest: PatchedResumeRequest, options?: RequestInit): Promise<onboardingProgressCurrentPartialUpdateResponse> => {
  
  return apiFetch<onboardingProgressCurrentPartialUpdateResponse>(getOnboardingProgressCurrentPartialUpdateUrl(),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchedResumeRequest,)
  }
);}




export const getOnboardingProgressCurrentPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof onboardingProgressCurrentPartialUpdate>>, TError,{data: PatchedResumeRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof onboardingProgressCurrentPartialUpdate>>, TError,{data: PatchedResumeRequest}, TContext> => {

const mutationKey = ['onboardingProgressCurrentPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof onboardingProgressCurrentPartialUpdate>>, {data: PatchedResumeRequest}> = (props) => {
          const {data} = props ?? {};

          return  onboardingProgressCurrentPartialUpdate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type OnboardingProgressCurrentPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof onboardingProgressCurrentPartialUpdate>>>
    export type OnboardingProgressCurrentPartialUpdateMutationBody = PatchedResumeRequest
    export type OnboardingProgressCurrentPartialUpdateMutationError = unknown

    export const useOnboardingProgressCurrentPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof onboardingProgressCurrentPartialUpdate>>, TError,{data: PatchedResumeRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof onboardingProgressCurrentPartialUpdate>>,
        TError,
        {data: PatchedResumeRequest},
        TContext
      > => {

      const mutationOptions = getOnboardingProgressCurrentPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * The wizard of the agency: only its owner and its managers run it.
 */
export type onboardingProgressFinishCreateResponse200 = {
  data: OnboardingState
  status: 200
}
    
export type onboardingProgressFinishCreateResponseSuccess = (onboardingProgressFinishCreateResponse200) & {
  headers: Headers;
};
;

export type onboardingProgressFinishCreateResponse = (onboardingProgressFinishCreateResponseSuccess)

export const getOnboardingProgressFinishCreateUrl = () => {


  

  return `/api/v1/onboarding/progress/finish/`
}

export const onboardingProgressFinishCreate = async ( options?: RequestInit): Promise<onboardingProgressFinishCreateResponse> => {
  
  return apiFetch<onboardingProgressFinishCreateResponse>(getOnboardingProgressFinishCreateUrl(),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getOnboardingProgressFinishCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof onboardingProgressFinishCreate>>, TError,void, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof onboardingProgressFinishCreate>>, TError,void, TContext> => {

const mutationKey = ['onboardingProgressFinishCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof onboardingProgressFinishCreate>>, void> = () => {
          

          return  onboardingProgressFinishCreate(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type OnboardingProgressFinishCreateMutationResult = NonNullable<Awaited<ReturnType<typeof onboardingProgressFinishCreate>>>
    
    export type OnboardingProgressFinishCreateMutationError = unknown

    export const useOnboardingProgressFinishCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof onboardingProgressFinishCreate>>, TError,void, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof onboardingProgressFinishCreate>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getOnboardingProgressFinishCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * The service templates (versioned data) and those the agency already has.
 */
export type onboardingProgressLibraryRetrieveResponse200 = {
  data: Library
  status: 200
}
    
export type onboardingProgressLibraryRetrieveResponseSuccess = (onboardingProgressLibraryRetrieveResponse200) & {
  headers: Headers;
};
;

export type onboardingProgressLibraryRetrieveResponse = (onboardingProgressLibraryRetrieveResponseSuccess)

export const getOnboardingProgressLibraryRetrieveUrl = (params?: OnboardingProgressLibraryRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/onboarding/progress/library/?${stringifiedParams}` : `/api/v1/onboarding/progress/library/`
}

export const onboardingProgressLibraryRetrieve = async (params?: OnboardingProgressLibraryRetrieveParams, options?: RequestInit): Promise<onboardingProgressLibraryRetrieveResponse> => {
  
  return apiFetch<onboardingProgressLibraryRetrieveResponse>(getOnboardingProgressLibraryRetrieveUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getOnboardingProgressLibraryRetrieveQueryKey = (params?: OnboardingProgressLibraryRetrieveParams,) => {
    return [
    `/api/v1/onboarding/progress/library/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getOnboardingProgressLibraryRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof onboardingProgressLibraryRetrieve>>, TError = unknown>(params?: OnboardingProgressLibraryRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof onboardingProgressLibraryRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOnboardingProgressLibraryRetrieveQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof onboardingProgressLibraryRetrieve>>> = ({ signal }) => onboardingProgressLibraryRetrieve(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof onboardingProgressLibraryRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OnboardingProgressLibraryRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof onboardingProgressLibraryRetrieve>>>
export type OnboardingProgressLibraryRetrieveQueryError = unknown


export function useOnboardingProgressLibraryRetrieve<TData = Awaited<ReturnType<typeof onboardingProgressLibraryRetrieve>>, TError = unknown>(
 params: undefined |  OnboardingProgressLibraryRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof onboardingProgressLibraryRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof onboardingProgressLibraryRetrieve>>,
          TError,
          Awaited<ReturnType<typeof onboardingProgressLibraryRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOnboardingProgressLibraryRetrieve<TData = Awaited<ReturnType<typeof onboardingProgressLibraryRetrieve>>, TError = unknown>(
 params?: OnboardingProgressLibraryRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof onboardingProgressLibraryRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof onboardingProgressLibraryRetrieve>>,
          TError,
          Awaited<ReturnType<typeof onboardingProgressLibraryRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOnboardingProgressLibraryRetrieve<TData = Awaited<ReturnType<typeof onboardingProgressLibraryRetrieve>>, TError = unknown>(
 params?: OnboardingProgressLibraryRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof onboardingProgressLibraryRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useOnboardingProgressLibraryRetrieve<TData = Awaited<ReturnType<typeof onboardingProgressLibraryRetrieve>>, TError = unknown>(
 params?: OnboardingProgressLibraryRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof onboardingProgressLibraryRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOnboardingProgressLibraryRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * The wizard of the agency: only its owner and its managers run it.
 */
export type onboardingProgressPublishSiteCreateResponse200 = {
  data: PublishedSite
  status: 200
}
    
export type onboardingProgressPublishSiteCreateResponseSuccess = (onboardingProgressPublishSiteCreateResponse200) & {
  headers: Headers;
};
;

export type onboardingProgressPublishSiteCreateResponse = (onboardingProgressPublishSiteCreateResponseSuccess)

export const getOnboardingProgressPublishSiteCreateUrl = () => {


  

  return `/api/v1/onboarding/progress/publish-site/`
}

export const onboardingProgressPublishSiteCreate = async ( options?: RequestInit): Promise<onboardingProgressPublishSiteCreateResponse> => {
  
  return apiFetch<onboardingProgressPublishSiteCreateResponse>(getOnboardingProgressPublishSiteCreateUrl(),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getOnboardingProgressPublishSiteCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof onboardingProgressPublishSiteCreate>>, TError,void, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof onboardingProgressPublishSiteCreate>>, TError,void, TContext> => {

const mutationKey = ['onboardingProgressPublishSiteCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof onboardingProgressPublishSiteCreate>>, void> = () => {
          

          return  onboardingProgressPublishSiteCreate(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type OnboardingProgressPublishSiteCreateMutationResult = NonNullable<Awaited<ReturnType<typeof onboardingProgressPublishSiteCreate>>>
    
    export type OnboardingProgressPublishSiteCreateMutationError = unknown

    export const useOnboardingProgressPublishSiteCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof onboardingProgressPublishSiteCreate>>, TError,void, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof onboardingProgressPublishSiteCreate>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getOnboardingProgressPublishSiteCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * The wizard of the agency: only its owner and its managers run it.
 */
export type onboardingProgressServicesCreateResponse200 = {
  data: Applied
  status: 200
}
    
export type onboardingProgressServicesCreateResponseSuccess = (onboardingProgressServicesCreateResponse200) & {
  headers: Headers;
};
;

export type onboardingProgressServicesCreateResponse = (onboardingProgressServicesCreateResponseSuccess)

export const getOnboardingProgressServicesCreateUrl = () => {


  

  return `/api/v1/onboarding/progress/services/`
}

export const onboardingProgressServicesCreate = async (applyServicesRequest: ApplyServicesRequest, options?: RequestInit): Promise<onboardingProgressServicesCreateResponse> => {
  
  return apiFetch<onboardingProgressServicesCreateResponse>(getOnboardingProgressServicesCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      applyServicesRequest,)
  }
);}




export const getOnboardingProgressServicesCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof onboardingProgressServicesCreate>>, TError,{data: ApplyServicesRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof onboardingProgressServicesCreate>>, TError,{data: ApplyServicesRequest}, TContext> => {

const mutationKey = ['onboardingProgressServicesCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof onboardingProgressServicesCreate>>, {data: ApplyServicesRequest}> = (props) => {
          const {data} = props ?? {};

          return  onboardingProgressServicesCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type OnboardingProgressServicesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof onboardingProgressServicesCreate>>>
    export type OnboardingProgressServicesCreateMutationBody = ApplyServicesRequest
    export type OnboardingProgressServicesCreateMutationError = unknown

    export const useOnboardingProgressServicesCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof onboardingProgressServicesCreate>>, TError,{data: ApplyServicesRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof onboardingProgressServicesCreate>>,
        TError,
        {data: ApplyServicesRequest},
        TContext
      > => {

      const mutationOptions = getOnboardingProgressServicesCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Done, skipped (listed « à compléter ») or reopened.
 */
export type onboardingProgressStepCreateResponse200 = {
  data: OnboardingState
  status: 200
}
    
export type onboardingProgressStepCreateResponseSuccess = (onboardingProgressStepCreateResponse200) & {
  headers: Headers;
};
;

export type onboardingProgressStepCreateResponse = (onboardingProgressStepCreateResponseSuccess)

export const getOnboardingProgressStepCreateUrl = () => {


  

  return `/api/v1/onboarding/progress/step/`
}

export const onboardingProgressStepCreate = async (stepActionRequest: StepActionRequest, options?: RequestInit): Promise<onboardingProgressStepCreateResponse> => {
  
  return apiFetch<onboardingProgressStepCreateResponse>(getOnboardingProgressStepCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      stepActionRequest,)
  }
);}




export const getOnboardingProgressStepCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof onboardingProgressStepCreate>>, TError,{data: StepActionRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof onboardingProgressStepCreate>>, TError,{data: StepActionRequest}, TContext> => {

const mutationKey = ['onboardingProgressStepCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof onboardingProgressStepCreate>>, {data: StepActionRequest}> = (props) => {
          const {data} = props ?? {};

          return  onboardingProgressStepCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type OnboardingProgressStepCreateMutationResult = NonNullable<Awaited<ReturnType<typeof onboardingProgressStepCreate>>>
    export type OnboardingProgressStepCreateMutationBody = StepActionRequest
    export type OnboardingProgressStepCreateMutationError = unknown

    export const useOnboardingProgressStepCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof onboardingProgressStepCreate>>, TError,{data: StepActionRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof onboardingProgressStepCreate>>,
        TError,
        {data: StepActionRequest},
        TContext
      > => {

      const mutationOptions = getOnboardingProgressStepCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    